import { Component, OnInit } from '@angular/core';
import CONFIG from '../../config';
import { BackendService } from 'src/app/shared/backend.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FAQComponent implements OnInit {
  FAQDataSource: any;
  constructor(public backendservice: BackendService,

  ) {

  }

  ngOnInit() {
    this.gettingData();
  }
  gettingData() {
    return this.backendservice.getData(CONFIG.FAQApiUrlBase).subscribe(response => {
      //console.log(response);
      this.FAQDataSource = response['getData']
     // console.log(this.FAQDataSource)
    });
  }
}
